import { FC } from 'react'
import styled from 'styled-components'

const NewsReactionLoading: FC = () => {
  return (
    <StyledWrapper>
      {new Array(5).fill('').map((_, index) => (
        <div key={index} className="loading" />
      ))}
    </StyledWrapper>
  )
}

export default NewsReactionLoading

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  gap: 10px;
  .loading {
    background-color: #eee;
    border-radius: 5px;
    height: 30px;
  }
`
